// extracted by mini-css-extract-plugin
export default {"root":"+sDY9","avatar":"oQniJ"};